import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Card, Button } from 'react-bootstrap';
import { FormSelect } from '@components/Common/AwpFormInputs';
import { OccurrenceOptionalFields } from '@components/Avalanche/OptionalFields';

const AvalancheControlPreferences = ({
  programs,
  areas,
  paths,
  avalancheTechs,
  controlTypes,
  formikProps,
  ctrEventOptPropsPrefixed,
  dto,
}) => {
  const [areaList, setAreaList] = useState(areas);
  const [pathsList, setPathsList] = useState(paths);

  useEffect(() => {
    if (dto?.program) {
      setAreaList(areas.filter((x) => x.parentId === dto.program.value));
    }

    if (dto?.area) {
      setPathsList(paths.filter((x) => x.parentId === dto.area.value));
    }
  }, [dto]);

  const programOnChange = (opt, setFieldValue) => {
    setFieldValue('control.area', null, false);
    setFieldValue('control.path', '', false);
    setAreaList(areas.filter((x) => x.parentId === opt.value));

    //path list is unfiltered
    setPathsList(paths);
  };

  const areaOnChange = (opt, setFieldValue) => {
    // filter the paths list to those for this area
    setPathsList(filterList(paths, opt.value));

    //clear path
    setFieldValue('control.path', '', false);
    setFieldValue(
      'control.program',
      programs.find((x) => x.value === opt.parentId),
    );
  };

  const filterList = (list, value) => {
    return list.filter(({ parentId }) => {
      return parentId === value;
    });
  };

  const pathOnChange = (opt, setFieldValue, pathListToUse) => {
    //if the user picked a path first, we'll auto select the area/program
    const _area = areas.find(({ value }) => {
      return value === opt.parentId;
    });

    //filter the area list to children of program
    setAreaList(filterList(areas, _area.parentId));

    //set area value
    setFieldValue('control.area', _area, false);

    //set program state form selected area
    setFieldValue(
      'control.program',
      programs.find(({ value }) => {
        return value === _area.parentId;
      }),
      false,
    );

    //ensure the paths are children of area
    let p = filterList(pathListToUse || pathsList, _area.value);
    setPathsList(p);
  };

  const handleReset = (formikProps) => {
    formikProps.setFieldValue('control.program', { value: '' }, false);
    formikProps.setFieldValue('control.area', { value: '' }, false);
    formikProps.setFieldValue('control.path', { value: '' }, false);
    formikProps.setFieldValue('control.aval_cntrl_type_cd', {}, false);
    formikProps.setFieldValue('control.blaster', { value: '' }, false);
    formikProps.setFieldValue('control.assistantBlaster', { value: '' }, false);

    setAreaList(areas);
    setPathsList(paths);

    ctrEventOptPropsPrefixed.forEach((prop) => {
      formikProps.setFieldValue(prop.ObservationName, '');
    });
  };

  return (
    <>
      <Card border="light" className="page-card">
        <Card.Header as="h3" style={{ backgroundColor: 'transparent' }}>
          AVALANCHE CONTROL
        </Card.Header>
        <Card.Body>
          <FormSelect
            className="avalanche-select"
            readOnly={false}
            name="control.program"
            id="control.program"
            label="Program"
            postChange={(e) => {
              programOnChange(e, formikProps.setFieldValue);
            }}
            options={programs}
            isMulti={false}
          />

          <FormSelect
            className="avalanche-select"
            readOnly={false}
            name="control.area"
            id="control.area"
            label="Avalanche Area"
            postChange={(e) => {
              areaOnChange(e, formikProps.setFieldValue);
            }}
            options={areaList}
            isMulti={false}
          />
          <FormSelect
            className="avalanche-select"
            readOnly={false}
            name="control.path"
            id="control.path"
            label="Path"
            postChange={(e) => {
              pathOnChange(e, formikProps.setFieldValue);
            }}
            options={pathsList}
            isMulti={false}
          />
          <FormSelect
            readOnly={false}
            name="control.aval_cntrl_type_cd"
            id="control.aval_cntrl_type_cd"
            label="Control Type"
            options={controlTypes}
            isMulti={false}
          />
          <OccurrenceOptionalFields
            readOnly={false}
            props={formikProps}
            eventProperties={ctrEventOptPropsPrefixed}
            isAccordion={false}
          />
          <FormSelect
            readOnly={false}
            name="control.blaster"
            id="control.blaster"
            label="Blaster"
            options={avalancheTechs.options}
            isMulti={false}
          />
          <FormSelect
            readOnly={false}
            name="control.assistantBlaster"
            id="control.assistantBlaster"
            label="Assistant Blaster"
            options={avalancheTechs.options}
            isMulti={false}
            isClearable={true}
          />
          <Button className="my-3" variant="outline-primary" onClick={() => handleReset(formikProps)}>
            Reset
          </Button>
        </Card.Body>
      </Card>
    </>
  );
};

AvalancheControlPreferences.propTypes = {
  programs: PropTypes.arrayOf(PropTypes.object),
  areas: PropTypes.arrayOf(PropTypes.object),
  paths: PropTypes.arrayOf(PropTypes.object),
  avalancheTechs: PropTypes.object,
  controlTypes: PropTypes.arrayOf(PropTypes.object),
  formikProps: PropTypes.object,
  ctrEventOptPropsPrefixed: PropTypes.array,
  dto: PropTypes.object,
};

export default AvalancheControlPreferences;
